<div class="dashboard-content">
  <h1 class="visually-hidden">Service Request History</h1>

  <div class="container-fluid mt-4">
    <div class="row" id="main-content">
      <div class="col-xxl-1"></div>
      <div class="col-xxl-10">
        <div class="row g-4 mb-3">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <div class="row align-items-center">
                  <div class="col-12 col-md-9 d-flex align-items-center">
                    <i class="card-title-icon fa-solid fa-headset material-icon-fa me-2" aria-hidden="true"></i>
                    <h2 class="dashboard-card-title">Service Request History</h2>
                  </div>
                  <div class="col-md-3 d-none d-md-flex justify-content-end">
                    <button class="btn btn-primary w-100 fs-6" mdbRipple routerLink="/service-requests">
                      Open a Service Request
                    </button>
                  </div>
                </div>
                <p class="dashboard-card-subtitle mt-1">Form reviews and assistance requests.</p>
                <div class="d-md-none mt-2">
                  <button class="btn btn-primary w-100" mdbRipple routerLink="/service-requests">
                    Open a Service Request
                  </button>
                </div>
              </div>

              <div class="card-body">
                @if (isLoading()) {
                <div class="text-center py-5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
                } @else if (dataSource().length > 0) {
                <div class="row g-3 mt-2 align-items-center justify-content-center">
                  <div class="col-12 col-md-8">
                    <div class="input-group">
                      <input type="text" class="form-control" id="search-input" #searchInput
                        placeholder="Search requests... (e.g., 'pending' or 'SR-2026 in:serviceRequestNo')"
                        aria-label="Search service requests" />
                      <button class="btn btn-primary" type="button" (click)="advancedSearch(searchInput.value)"
                        aria-label="Search">
                        <i class="fa fa-search" aria-hidden="true"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="table-responsive d-none d-md-block">
                      <div class="datatable mt-4">
                        <table class="table datatable-table" mdbTable mdbTableSort #table="mdbTable"
                          #sort="mdbTableSort" [dataSource]="dataSource()" [sort]="sort" [pagination]="pagination"
                          [filterFn]="filterFn" aria-label="Service Request History">
                          <thead class="datatable-header fw-bold fs-5">
                            <tr>
                              @for (header of headers; track header) {
                              <th [mdbTableSortHeader]="header" scope="col">{{ header }}</th>
                              }
                            </tr>
                          </thead>
                          <tbody class="datatable-body fs-6">
                            @for (request of table.data; track request.serviceRequestId) {
                            <tr>
                              <td class="fw-semibold">
                                {{ formatServiceRequestId(request.serviceRequestId) }}
                              </td>
                              <td>
                                <div class="chip-outline" [class]="getStatusClass(request.status)">
                                  {{ getStatusDisplay(request.status) | titlecase }}
                                </div>
                              </td>
                              <td class="fw-regular">
                                <span [title]="request.description" class="service-request-description"
                                  [attr.aria-label]="request.description">
                                  {{ request.description }}
                                </span>
                              </td>
                              <td class="fw-regular">
                                {{ request.modifiedDate ? formatDate(request.modifiedDate) : 'N/A' }}
                              </td>
                              <td>
                                <button type="button" class="btn btn-sm btn-primary"
                                  [routerLink]="['/service-request-details', request.serviceRequestId]"
                                  [attr.aria-label]="'View details for ' + formatServiceRequestId(request.serviceRequestId)">
                                  View
                                </button>
                              </td>
                            </tr>
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div class="mobile-service-request-list d-md-none mt-4" role="list"
                      aria-label="Service Request History">
                      @for (request of table.data; track request.serviceRequestId) {
                      <article class="service-request-item" role="listitem">
                        <div class="chip-outline mb-2" [class]="getStatusClass(request.status)">
                          {{ getStatusDisplay(request.status) | titlecase }}
                        </div>

                        <div class="service-request-time justify-content-center">
                          <i class="fa-solid fa-stopwatch material-icon-fa" aria-hidden="true"></i>
                          <span class="service-request-field-label">Last updated:</span>
                          <span>{{ request.modifiedDate ? formatDate(request.modifiedDate) : 'N/A' }}</span>
                        </div>

                        <hr class="my-3" />

                        <h3 class="service-request-title">
                          {{ formatServiceRequestId(request.serviceRequestId) }}
                        </h3>
                        <div class="service-request-description mb-3">
                          <span class="service-request-field-label">Description:</span>
                          {{ request.description }}
                        </div>

                        <button type="button" class="btn btn-primary w-100"
                          [routerLink]="['/service-request-details', request.serviceRequestId]"
                          [attr.aria-label]="'View details for ' + formatServiceRequestId(request.serviceRequestId)">
                          View
                        </button>
                      </article>
                      }
                    </div>

                    <mdb-table-pagination #pagination></mdb-table-pagination>
                  </div>
                </div>
                } @else {
                <div class="dashboard-empty-state">
                  <i class="fa-solid fa-headset material-icons" aria-hidden="true"></i>
                  <div class="dashboard-empty-state-title">No Service Requests</div>
                  <div class="dashboard-empty-state-message">
                    You don't have any service requests yet. When you submit a service request, it
                    will appear here.
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
        </div>

        <app-gradientsegmentbar></app-gradientsegmentbar>
      </div>
      <div class="col-xxl-1"></div>
    </div>
  </div>
</div>
